import { debounce } from 'lodash';

import { buildSelectableStudent } from '@/utils/buildSelectable';

import { search } from '@/api/StudentApi';

import { Selectable } from '@/components/selectBox/selectBox';

export function useStudentsSearch(searchFilters?: Record<string, unknown>) {
  const searchQuery = ref('');
  const isLoading = ref(false);
  const studentOptions = ref<Selectable<number>[]>([]);
  const localSearchFilters = ref(searchFilters);

  const searchStudents = debounce(async (query: string) => {
    const response = await search({
      filters: {
        ...localSearchFilters.value,
        search: query
      }
    });
    studentOptions.value = response.map((student) =>
      buildSelectableStudent(student)
    ) as Selectable<number>[];

    isLoading.value = false;
  }, 300);

  function updateSearchFilters(searchFilters?: Record<string, unknown>) {
    localSearchFilters.value = searchFilters;
    searchStudents(searchQuery.value);
  }

  function onQueryChange(query: string): void {
    isLoading.value = true;
    searchQuery.value = query;

    searchStudents(query);
  }

  return {
    studentOptions,
    searchStudents,
    isLoading,
    onQueryChange,
    updateSearchFilters
  };
}
